
export default {
    data() {
        return {
            openNavBar: false,
        };
    },
    props: ['buttonOrange', 'buttonPink', 'campusText', 'campusLogoHeader',
        'campusLogoHeaderValidation', 'global',],
    mounted() {
    }
}
